import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import {
  Warning as WarningIcon,
  Info as InfoIcon,
  Error as ErrorIcon,
} from '@mui/icons-material';

const severityIcons = {
  info: <InfoIcon />,
  warning: <WarningIcon />,
  error: <ErrorIcon />,
};

function ServiceAlertBanner({ alerts }) {
  if (!alerts || alerts.length === 0) return null;

  return (
    <Box sx={{ mb: 3 }}>
      {alerts.map((alert) => (
        <Alert
          key={alert.id}
          severity={alert.severity}
          icon={severityIcons[alert.severity]}
          sx={{ mb: 1 }}
        >
          <AlertTitle>{alert.title}</AlertTitle>
          <span style={{ whiteSpace: 'pre-line' }}>{alert.message}</span>
        </Alert>
      ))}
    </Box>
  );
}

export default ServiceAlertBanner;
